import { EntityBadge, EntityBadgeProps } from "src/components/badges/entity";

/**
 * The properties for {@link SubnetBadge}
 */
export type SubnetBadgeProps = Omit<EntityBadgeProps, "entity" | "prefix" | "href" | "params"> & {
    /**
     * The subnet this badge is for
     *
     * The type is intentionally not from the generated sdk
     * to support as many caller as possible
     */
    subnet: { uuid: string; name: string; description?: string };
};

/**
 * A badge labeled `subnet:name` linking to the subnet's page
 */
export function SubnetBadge(props: SubnetBadgeProps) {
    const { subnet, ...rest } = props;

    return (
        <EntityBadge
            {...rest}
            entity={subnet}
            prefix={"subnet"}
            href={"/a/subnets/$subnetId/inbound-acls"}
            params={{ subnetId: subnet.uuid }}
        />
    );
}
